var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"options shadow"},[_c('div',{staticClass:"options-header "},[_c('h5',{staticClass:"text-dark border-bottom m-0 pb-2"},[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"options-content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }